export const COMPANY = {
  legalName: "Nom Apps LLC",
  location: "Wisconsin, United States",
  email: "support@nomappsllc.com",
  domain: "nomappsllc.com",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -88, duration: 1.1 });
  else el.scrollIntoView({ behavior: "smooth" });
};
